import { MediaMatcher } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { IPermission } from '../core/interfaces/DB/i-permission';
import { IResponse } from '../core/interfaces/Responses/i-responses';
import { SidenavMenu } from '../core/interfaces/UI/i-menu';
import { AuthService } from '../core/services/api/auth.service';
import { RolService } from '../core/services/api/rol.service';
import { MenuService } from '../core/services/local/menu.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit, OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  title: string;
  perms: IPermission[];

  currentUser: any; // datos de sesion
  // menu
  public sidenavMenuItems: SidenavMenu[] = [];
  sidenavMenuItemsOriginal: SidenavMenu[] = [];
  opened: boolean = false;
  constructor(
    private authService: AuthService,
    private rolService: RolService,
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private menuService: MenuService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.authService.currentUser.subscribe((next) => {
      this.currentUser = next;

    });
    this.authService.currentPerms.subscribe((next) => {

      this.perms = next;
      if (this.sidenavMenuItems && this.sidenavMenuItems.length > 0) {
        this.activeMenuItems();
      }
    });



    this.menuService.showDbObjectView.subscribe((next) => {

    });


  }
  ngAfterViewInit(): void {
    this.menuService.titleName.subscribe((next) => {
      this.title = next;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnInit(): void {
    this.onLoad();
  }




  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  onLoad(): void {
    this.getMenu();

  }

  // loadPermission() {
  //   this.rolService.GetPermissionsByRolId(this.currentUser.RolId).subscribe({
  //     next: (res: IResponse<IPermission[]>) => {
  //       if (res.Result) {
  //         this.authService.SetPermissions(res.Data)
  //       } else {

  //       }
  //     },
  //     error: (err: string) => {

  //     },
  //   });
  // }

  // OBTENEMOS EL MENU
  public getMenu(): any {

    this.menuService.getMenu().subscribe({
      next: (data: SidenavMenu[]) => {

        this.sidenavMenuItems.length = 0;
        this.sidenavMenuItemsOriginal = data;
        this.activeMenuItems()



      },
      error: (err: string) => {

        console.log('Error obteniendo el menu', err);
      },
    });
  }
  activeMenuItems() {

    this.sidenavMenuItems = this.sidenavMenuItemsOriginal.filter(i => i.active);
    this.sidenavMenuItems.forEach(i => i.submenu = i.submenu?.filter(s => s.active));
    this.sidenavMenuItems = this.checkMenuPerms(this.sidenavMenuItems);

    this.menuService.setMenu(this.sidenavMenuItems)

  }

  checkMenuPerms(menu: SidenavMenu[]) {
    menu.forEach((menuElement) => {
      if (menuElement.id === 1) menuElement.havePerm = true;

      menuElement.havePerm =
        menuElement.id === 1 ? true : this.authService.checkPerm(menuElement.perm);
      if (menuElement.submenu.length > 0) {
        menuElement.submenu.forEach((submenuElement) => {
          submenuElement.havePerm = (submenuElement.id === 24)
            ? this.authService.isAdmin() && this.authService.checkPerm(submenuElement.perm)
            : submenuElement.havePerm = this.authService.checkPerm(submenuElement.perm)
          //submenuElement.havePerm = this.authService.checkPerm(submenuElement.perm);
        });
      }
    });
    return menu;
  }

}
